export const LOGIN_OR_REGISTRATION_MODAL_NAME = 'loginOrRegistration';
